import { FEED_TABS, type FeedTab } from "../types";
import { useTabCounts } from "../hooks";

/**
 * Redesign · filter row 2 (sealed mock). The status filter — the same boxed pill
 * component as the signal-type row, with the server count inline in Mono. Also
 * single-select, so it is a radiogroup of radios. The active tab is owned by the
 * URL query in the page container; this component is presentational and reports
 * changes up. Counts are omitted while loading.
 */
export function OwnershipTabs({
  active,
  onChange,
  viewerId,
}: {
  active: FeedTab;
  onChange: (tab: FeedTab) => void;
  viewerId: string;
}): JSX.Element {
  const { data } = useTabCounts(viewerId);

  return (
    <div className="sx-filters">
      <p className="sx-f-eyebrow">Status</p>
      <div className="sx-pill-row" role="radiogroup" aria-label="Status">
        {FEED_TABS.map((tab) => {
          const count = data ? data[tab.key] : null;
          return (
            <button
              key={tab.key}
              type="button"
              role="radio"
              aria-checked={active === tab.key}
              className="sx-typepill"
              onClick={() => onChange(tab.key)}
            >
              {tab.label}
              {count !== null ? (
                <span className="sx-pct">
                  {count.toLocaleString()}
                  <span className="sx-sr-only">
                    {" "}
                    {count === 1 ? "signal" : "signals"}
                  </span>
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
